import { inject, injectable } from 'inversify'
import {
  DeleteMyArticleUseCaseInput,
  DeleteMyArticleUseCaseOutput,
  IAppErrorFactory,
  IArticlesService,
  IDeleteMyArticleUseCase,
} from '../../types'
import symbols from '../../symbols'

@injectable()
export default class DeleteMyArticleInteractor implements IDeleteMyArticleUseCase {
  @inject(symbols.IArticlesService) private articlesService: IArticlesService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: DeleteMyArticleUseCaseInput): Promise<DeleteMyArticleUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      output.article = await this.articlesService.deleteMyArticle({
        id: input.id,
      })
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): DeleteMyArticleUseCaseOutput {
    return {
      article: null,
      error: null,
    }
  }
}
